"use strict";
/**
 * Weekly Report V2 — Template Types
 *
 * Types for the template registry system that manages section templates,
 * slot definitions, and variant degradation.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionSlotName = void 0;
// ============================================================================
// SECTION SLOT NAMES
// ============================================================================
/** Typed slot names per section. Source of truth for all slot identifiers. */
exports.SectionSlotName = {
    COVER: {
        HERO_HEADLINE: 'heroHeadline',
        HERO_SUBLINE: 'heroSubline',
        WEEK_LABEL: 'weekLabel',
    },
    SKIN_SNAPSHOT: {
        HOLISTIC_OVERVIEW: 'holisticOverview',
        HERO_METRIC: 'heroMetric',
        METRIC_GROUPS: 'metricGroups',
    },
    NOTABLE_CHANGES: {
        PULL_QUOTE: 'pullQuote',
        DETAIL: 'detail',
        CHART: 'chart',
        EMERGING: 'emerging',
    },
    ROUTINE: {
        PRODUCTS: 'products',
        TREATMENTS: 'treatments',
    },
    SUGGESTIONS: {
        OBSERVATIONS: 'observations',
        DISCLAIMER: 'disclaimer',
    },
    CONTEXT: {
        OBSERVATIONS: 'observations',
    },
    CLOSE: {
        CLOSE_PROSE: 'closeProse',
        KEEP_SCANNING_PROMPT: 'keepScanningPrompt',
        GOAL_REFLECTIONS: 'goalReflections',
    },
};
//# sourceMappingURL=template.js.map